export const SET_SITE_UNIT_EVENTS = 'SET_SITE_UNIT_EVENTS';
export const SET_ERRORS = 'SET_ERRORS';
